import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { resetError, selectError, signUp } from "../../redux/users/usersSlice";
import Input from "../Input";
import { SignUpSchema } from "../../utils/formik-schema/signupSchema";
import { getAllCompanies } from "../../redux/company/companySlice";
import { Icon } from "@iconify-icon/react/dist/iconify.mjs";

const initialValues = {
  name: "",
  email: "",
  password: "",
  role: "",
  company:""
};

function EmployeeForm({ company, setRefresh, closeModal }) {
  const error = useSelector(selectError);
  const dispatch = useDispatch();


  const handleSignUp = async (values, { resetForm }) => {
    try {
      values.company = company?.id;
      const result = await dispatch(signUp(values)).unwrap();

      toast.success("Account created successfully!");
      resetForm();
      setRefresh(true);
      closeModal(false);
    } catch (err) {
      // Error handled
    }
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(resetError());
    }
  }, [error, dispatch]);

  return (
    <div className="w-96">
      <h2 className="text-2xl font-semibold text-gray-900 my-4">
        Create Employee Account
      </h2>

      <p className="mb-4 text-lg ">Enter your information</p>
      <Formik
        initialValues={initialValues}
        validationSchema={SignUpSchema}
        onSubmit={handleSignUp}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form className="flex flex-col" onSubmit={handleSubmit}>
            <Input
              name="name"
              type="text"
              placeholder="Name"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.name}
              touched={touched.name}
            />
            <Input
              name="email"
              type="email"
              placeholder="Email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.email}
              touched={touched.email}
            />
            <Input
              name="password"
              type="password"
              placeholder="Password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.password}
              touched={touched.password}
            />
            <select
              className="p-2 mt-3 mb-4 border rounded-md"
              name="role"
              value={values.role}
              onChange={handleChange}
              onBlur={handleBlur}
              required
            >
              <option value="">Select Role</option>
              <option value="employee">Employee</option>
              <option value="supervisor">Supervisor</option>
            </select>

            {/* <div className="my-4">
                  <label className="text-lg font-semibold">
                    Select Company:
                  </label>
                  <select
                    className="w-full p-2 mx-2 border rounded-md"
                    value={selectedCompanyId}
                    onChange={handleAdminChange}
                    required
                  >
                    <option value="" disabled>
                      Select Company
                    </option>
                    {allCompanies?.companies.map((company) => (
                      <option key={company.id} value={company.id}>
                        {company.name}
                      </option>
                    ))}
                  </select>
                </div> */}

            <button
              className="px-6 py-2 mt-4 text-white transition duration-300 bg-black rounded-md hover:bg-gray-800"
              type="submit"
            >
              Sign Up
            </button>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default EmployeeForm;
